import httpUtil from "@/utils/httpUtil";

/**获取类型商品列表 */
export const getGoodsInfoPCShop = async params => httpUtil.post("/api/crmPc/companyGoods/getGoodsInfoPCShop", params);
